import React from 'react';
import { bool, object, objectOf, oneOfType, string } from 'prop-types';
import _get from 'lodash/get';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import classNames from 'classnames/bind';
import ProductSearch from 'yoda-site-components/lib/components/ProductSearchOld/ProductSearch';
import HelpSection from 'yoda-site-components/lib/components/YodaFooter/components/HelpSection';
import CertonaZone from 'yoda-site-components/lib/components/CertonaZone/CertonaZone';
import makeQuery from 'yoda-core-components/lib/navigation/query/makeQuery';
import { selectPreferences } from 'yoda-site-components/lib/selectors/ContextSelector';
import * as styles from './NoSearchResults.css';
import { noSearchResult } from '../../common/constants';

const cx = classNames.bind(styles);

const NoSearchResults = (props) => {
    const {
        commonData: { gallery },
        featureFlags: { enableV2URL, isDisplaySRPMedaliaSurvey },
        location,
        preferences,
    } = props;

    const {
        findAStore,
        noProductsFound,
        searchTips,
        suggestionList,
        suggestionWithStoreLink,
        tryNewKeyword,
    } = noSearchResult;

    const footerHelpSection = _get(preferences, 'footer.HelpSection', {});

    const slotDetails = {
        attributes: { recommendations: true },
        loader: 'certona',
        pageType: 'NOSEARCH',
        slotId: 'nosearch1_rr',
    };

    if (!gallery) return null;

    const { Ntt, searchTerm } = makeQuery(location.search);

    const assistanceContainerClasses = ['bg-gray-500', cx('assistance-container')].join(' ');

    const assistanceListClasses = [cx('assistance-list')].join(' ');

    const helpWrapperClasses = ['bg-gray-500', cx('help-wrapper')].join(' ');

    const linkDescriptionClasses = ['inline-block', 'ml-2', cx('link-description')].join(' ');

    const listSectionClasses = ['block', 'mb-2 mt-2', 'pl-2', 'w-full', cx('list-section')].join(
        ' '
    );

    const searchTipsClasses = [
        'block',
        'capitalize',
        'font-open-sans-bold',
        'text-medium',
        cx('search-tips'),
    ].join(' ');

    const suggestionWrapperClasses = ['block', cx('suggestion-wrapper')].join(' ');

    const titleClasses = ['font-open-sans-bold', 'text-color-600', 'text-large'].join(' ');

    const wrapperClasses = ['mb-2 mt-2', 'pb-2 pl-2 pr-2 pt-2'].join(' ');

    const displayMedaliaSurvey = (isDisplayPLPMedaliaSurvey) => {
        // added !__SERVER_ condition on serverside srp div id is replacing with plp medalia div id
        if (isDisplayPLPMedaliaSurvey && !__SERVER__) {
            return (
                <div
                    id="srp_survey_inline"
                    className="hidden pb-2 pt-2 relative w-full"
                    data-automation-id="srp_survey_link"
                />
            );
        }
        return '';
    };

    return (
        <>
            <div className={wrapperClasses}>
                <div className={cx('content-wrapper')}>
                    <h2 className={titleClasses}>
                        {`${noProductsFound} ${enableV2URL ? searchTerm : Ntt}`}
                    </h2>
                    <div className="font-open-sans-bold mb-2 mt-2 text-medium">{tryNewKeyword}</div>
                    <div className="mb-2 mt-2">
                        <ProductSearch
                            automationId="tablet-search-block"
                            isNoResultsProductSearch
                        />
                    </div>
                    <div className={suggestionWrapperClasses}>
                        <div className={searchTipsClasses}>{searchTips}</div>
                        <div className={listSectionClasses}>
                            <ul className="list-disc pl-1 text-medium">
                                {suggestionList.map((suggestion) => (
                                    <li className="mb-2 mt-2" key={suggestion.id}>
                                        {suggestion.text}
                                    </li>
                                ))}
                                <li className="mb-2 mt-2">
                                    {suggestionWithStoreLink}
                                    &nbsp;
                                    <a
                                        href="/findastore"
                                        className="active:underline focus:underline hover:underline text-gray-600 underline visited:underline"
                                    >
                                        {findAStore}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className={assistanceContainerClasses}>
                            <HelpSection
                                automationId="footer-help"
                                contactLink="block text-left"
                                description={linkDescriptionClasses}
                                footerHelpSection={footerHelpSection}
                                iconTheme="align-top inline-block"
                                listClass={assistanceListClasses}
                                pretext="block text-left"
                                wrapperTheme={helpWrapperClasses}
                            />
                        </div>
                    </div>
                    {displayMedaliaSurvey(isDisplaySRPMedaliaSurvey)}
                </div>
            </div>
            <div className={wrapperClasses}>
                <CertonaZone
                    page={slotDetails.pageType}
                    slotDetails={slotDetails}
                    schemasToRender={slotDetails.slotId}
                />
            </div>
        </>
    );
};

NoSearchResults.propTypes = {
    commonData: oneOfType([bool, object, string]).isRequired,
    featureFlags: objectOf(bool).isRequired,
    preferences: objectOf(object).isRequired,
    location: objectOf(object),
};

NoSearchResults.defaultProps = {
    location: {},
};

const mapStateToProps = (store) => ({
    commonData: store.commonData,
    deviceType: store.context.deviceType,
    featureFlags: store.context.featureFlags,
    preferences: selectPreferences(store),
});

export default withRouter(connect(mapStateToProps)(NoSearchResults));
